import { States } from 'safe'
import {
  SET_CLIENTS,
  SET_CLIENT,
  UPDATE_CLIENT,
  DELETE_CLIENT,
  ClientTypes,
  GET_CLIENTS_BY_SELLERS,
  SellerTypes,
} from '../actions/actionTypes'

const initialState: States.ClientsBySeller = {
  clientsSeller: [],
  numberOfPages: 0,
}

export default (
  state = initialState,
  action: SellerTypes
): States.ClientsBySeller => {
  switch (action.type) {
    case GET_CLIENTS_BY_SELLERS:
      return { ...action.payload }
    default:
      return state
  }
}
